export default __webpack_public_path__ + "static/media/aprovec_ds.ceac6681.png";